import { object, string } from 'yup'
import { t } from 'ttag'

import { NAME_FIELD } from './hooks'

export const MAX_NAME_CHARACTERS = 50

export const getSchema = () =>
  object().shape({
    [NAME_FIELD]: string()
      .max(
        MAX_NAME_CHARACTERS,
        t`Name cannot exceed ${MAX_NAME_CHARACTERS} characters.`,
      )
      .required(t`This field cannot be empty.`),
  })
